const collectFieldNames = fields => {
  if (!Array.isArray(fields)) {
    return [];
  }

  return fields.reduce((result, field) => {
    if (field?.name) {
      result.push(field.name);
    }

    result.push(...collectFieldNames(field?.fields));

    return result;
  }, []);
};

const formSchemaFieldNames = formData => {
  const names = collectFieldNames(formData?.fields);
  const tabs = formData?.tabs?.data || formData?.tabs || [];

  if (Array.isArray(tabs)) {
    tabs.forEach(tab => {
      names.push(...collectFieldNames(tab?.fields));
    });
  }

  return [...new Set(names)];
};

const findFieldByName = (fields, fieldName) => {
  if (!Array.isArray(fields)) {
    return null;
  }

  for (const field of fields) {
    if (field?.name === fieldName) {
      return field;
    }

    const nestedField = findFieldByName(field?.fields, fieldName);

    if (nestedField) {
      return nestedField;
    }
  }

  return null;
};

const formSchemaFieldByName = (formData, fieldName) => {
  const field = findFieldByName(formData?.fields, fieldName);

  if (field) {
    return field;
  }

  const tabs = formData?.tabs?.data || formData?.tabs || [];

  if (!Array.isArray(tabs)) {
    return null;
  }

  for (const tab of tabs) {
    const tabField = findFieldByName(tab?.fields, fieldName);

    if (tabField) {
      return tabField;
    }
  }

  return null;
};

const removeMissingFormFields = ({ store, gridName, formData }) => {
  const form = store?.state?.grid?.[gridName]?.form;

  if (!form) {
    return;
  }

  const schemaFieldNames = formSchemaFieldNames(formData);

  Object.keys(form).forEach(field => {
    if (!schemaFieldNames.includes(field)) {
      store.commit("resetFormField", { grid_name: gridName, field });
    }
  });
};

const removeHiddenFormField = ({ store, gridName, formData, fieldName }) => {
  const form = store?.state?.grid?.[gridName]?.form;

  if (!form?.[fieldName]) {
    return;
  }

  const field = formSchemaFieldByName(formData, fieldName);

  if (!field?.depend_from) {
    return;
  }

  if (field?.depend_from?.not_reset_value) {
    return;
  }

  store.commit("resetFormField", { grid_name: gridName, field: fieldName });
};

module.exports = {
  formSchemaFieldByName,
  formSchemaFieldNames,
  removeHiddenFormField,
  removeMissingFormFields,
};
